<template>
  <div class="container">
    <div class="row">
      <div class="col-12 col-lg-8 mx-auto">
        <component
          :is="`v-${componentType}`"
          v-if="componentType"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { ui } from '@/mixins';
import ScheduleModal from './ScheduleModal.vue';
import CrossSellModal from './CrossSellModal.vue';
import PasswordModal from './PasswordModal.vue';
import FeedbackModal from './FeedbackModal.vue';
import BankAccountModal from './BankAccountModal.vue';
import ComplementaryInformationModal from './ComplementaryInformationModal.vue';
import AmendmentModal from './AmendmentModal.vue';
import DeleteAccountModal from './DeleteAccountModal.vue';
import AccountModal from './AccountModal.vue';

export default {
  components: {
    'v-schedule': ScheduleModal,
    'v-cross-sell': CrossSellModal,
    'v-password': PasswordModal,
    'v-feedback': FeedbackModal,
    'v-bank-account': BankAccountModal,
    'v-complementary-information': ComplementaryInformationModal,
    'v-amendment': AmendmentModal,
    'v-delete-account': DeleteAccountModal,
    'v-account': AccountModal,
  },
  mixins: [ui],
  computed: {
    ...mapGetters({
      componentType: 'ui/dynamicComponentType',
    }),
    aws: () => `${import.meta.env.VITE_AWS_STATIC}/common/png`,
  },
};
</script>
